import React from 'react'
import { NavLink } from 'react-router-dom'
import RailTooltip from '@/component/layout/SideNav/RailTooltip.tsx'

export interface INavItem {
    id: string
    label: string
    href: string
    icon?: React.FC<React.SVGProps<SVGSVGElement>>
    disabled?: boolean
}

export interface IProps extends INavItem {
    className?: string
    isRail?: boolean
}

const SideNavItem: React.FC<IProps> = ({ className, id, label, href, icon: Icon, disabled = false, isRail = false }) => {
    const navLinkClassName = ({ isActive }: { isActive: boolean }) =>
        [
            'app-side-nav__link',
            isActive ? 'app-side-nav__link--active' : ''
        ].join(' ')
    const indicator = Icon ? <Icon aria-hidden /> : label.trim().charAt(0)

    return (
        <RailTooltip className={className} label={label} enabled={isRail}>
            {!disabled ?
                <NavLink
                    to={href}
                    aria-label={isRail ? label : undefined}
                    className={navLinkClassName}>
                    <span className={'app-side-nav__indicator'}>{indicator}</span>
                    <span className={'app-side-nav__label'}>{label}</span>
                </NavLink> :
                <p className={'app-side-nav__link app-side-nav__link--disabled'} aria-label={isRail ? label : undefined}>
                    <span className={'app-side-nav__indicator'}>{id === 'connecting-crew' ? '+' : indicator}</span>
                    <span className={'app-side-nav__label'}>{label}</span>
                </p>
            }
        </RailTooltip>
    )
}

export default SideNavItem
